module.exports = __webpack_public_path__ + "img/pnl-1.e1795c1c.jpg";